export default __webpack_public_path__ + "static/media/e-book-new.f7c3d4e9.pdf";